<template>
  <b-row>
    <b-col cols="12" md="4" lg="2" class="d-flex flex-column" v-for="product in products" :key="product.category">
      <router-link class="d-flex flex-column flex-grow-1" style="margin-bottom: 2rem;" v-tracker="'card:' + product.category" :to="{ name: product.route }">
        <b-card class="py-2 d-flex flex-column flex-grow-1 mb-0">
          <b-card-body class="d-flex flex-column flex-grow-1">
            <div class="text-center mb-2">
              <img
                class="px-25 mb-2"
                style="width: 4em;"
                :src="product.image"
                :alt="product.category"
              />
              <h3 style="color:#024D67; font-size: 1rem; font-weight:bold">{{ product.category }}</h3>
            </div>
            <b-card-text class="text-center text-body c-text">
              {{ product.description }}
            </b-card-text>
          </b-card-body>
        </b-card>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
import { BCol, BCard, BCardBody, BCardText, BRow } from 'bootstrap-vue'
import ProductSliders from './ProductSliders.vue';

export default {
  components: {
    BCol,
    BCard,
    BCardText,
    BRow,
  },

  data() {
    return {
      products: [
        {
          category: 'COMMUNICATION',
          description:'',
          image: require('@/assets/images/products/unit/Icon - Communication.png'),
          route: 'product-category-communication',
        },
        {
          category: 'DATACOMM',
          description:'',
          image: require('@/assets/images/products/unit/Icon - Datacomm.png'),
          route: 'product-category-datacomm',
        },
        {
          category: 'INTERNET',
          description:'',
          image: require('@/assets/images/products/unit/Icon - Internet.png'),
          route: 'product-category-internet',
        },
        {
          category: 'WIRELESS',
          description:'',
          image: require('@/assets/images/products/unit/Icon - Wireless.png'),
          route: 'product-category-wireless',
        },
        {
          category: 'CYBER SECURITY',
          description:'',
          image: require('@/assets/images/products/unit/CyberSecurity.png'),
          route: 'product-category-cyber-security',
        }
      ],
    }
  },
  mounted() {
    this.fetchProductSettings()
  },
  methods: {
    fetchProductSettings() {
      this.$http.get('/settings/product').then(({ data }) => {
        this.products[0].description = data.data.communication
        this.products[1].description = data.data.datacomm
        this.products[2].description = data.data.internet
        this.products[3].description = data.data.wireless
        this.products[4].description = data.data.cyberSecurity
      })
    }
  }
}
</script>
<style>
@media (min-width: 992px) {
  h4 {
    font-size: 1rem;
  }
}

@media (max-width: 991px) {
  h4 {
    font-size: 0.5rem;
  }
}

</style>
<!-- <template>
  <b-row class="d-flex justify-content-start">
    <b-col md="2" v-for="product in products" :key="product.category">
      <router-link v-tracker="'card:' + product.category" :to="{ name: product.route }">
        <b-card>
          <div class="text-center mb-2">
            <img
              class="px-25 mb-2 w-50"
              :src="product.image"
              :alt="product.category"
            />
            <h4 style="color:#024D67; font-weight:bold">{{product.category}}</h4>
          </div>
          <b-card-text
            style="height: 10rem; text-align: justify;"
            class="text-body c-text text-center"
          >
            {{ product.description }}
          </b-card-text>
        </b-card>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>
import { BCol, BCard, BCardText, BRow } from 'bootstrap-vue'
import ProductSliders from './ProductSliders.vue';

export default {
  components: {
    BCol,
    BCard,
    BCardText,
    BRow,
  },

  data() {
    return {
      products: [
        {
          category: 'COMMUNICATION',
          description:'',
          image: require('@/assets/images/products/unit/Icon - Communication.png'),
          route: 'product-category-communication',
        },
        {
          category: 'DATACOMM',
          description:'',
          image: require('@/assets/images/products/unit/Icon - Datacomm.png'),
          route: 'product-category-datacomm',
        },
        {
          category: 'INTERNET',
          description:'',
          image: require('@/assets/images/products/unit/Icon - Internet.png'),
          route: 'product-category-internet',
        },
        {
          category: 'WIRELESS',
          description:'',
          image: require('@/assets/images/products/unit/Icon - Wireless.png'),
          route: 'product-category-wireless',
        },
        {
          category: 'CYBER SECURITY',
          description:'',
          image: require('@/assets/images/products/unit/CyberSecurity.png'),
          route: 'product-category-cyber-security',
        }
      ],
    }
  },
  mounted() {
    this.fetchProductSettings()
  },
  methods: {
    fetchProductSettings() {
      this.$http.get('/settings/product').then(({ data }) => {
        console.log(this.products)
        this.products[0].description = data.data.communication
        this.products[1].description = data.data.datacomm
        this.products[2].description = data.data.internet
        this.products[3].description = data.data.wireless
        this.products[4].description = data.data.cyberSecurity
      })
    }
  }
}
</script>
<style>
@media (min-width: 992px) {
  h4 {
    font-size: 1rem;
  }
}

@media (max-width: 991px) {
  h4 {
    font-size: 0.5rem;
  }
}

</style> -->
